import { getTemplateByIds } from '../api/template';
import { TEMPLATE_NAME } from './constants';

/**
 * @type {import('./index.d').initSettingsProvider}
 */
export async function initSettingsProvider(appContext) {
  const backInStockSettings = appContext.app?.backInStock || {};

  const productSettings = getProductSettings(backInStockSettings);
  const templateSettings = await getTemplateSettings(appContext, TEMPLATE_NAME);

  const settingsProvider = {
    settings() {
      return backInStockSettings;
    },
    productSettings() {
      return productSettings;
    },
    templateSettings() {
      return templateSettings;
    },
  };

  return settingsProvider;
}

/**
 * @type {import('./index.d').getProductSettings}
 */
function getProductSettings(settings = {}) {
  const {
    productSettings: {
      showOnPreOrderProduct = { show: false },
      showOnVariantOutOfStock = { show: false },
      hideOnSpecificCollection = { hide: false, collectionIds: [] },
      hideOnSpecificTag = { hide: false, tags: [] },
    } = {},
  } = settings;

  return {
    showOnPreOrderProduct,
    showOnVariantOutOfStock,
    hideOnSpecificCollection,
    hideOnSpecificTag,
  };
}

/**
 * @type {import('./index.d').getTemplateSettings}
 */
async function getTemplateSettings(appContext, name) {
  const { template = {} } = appContext.app || {};
  let backInStockTemplate = template.backInStockTemp;

  if (!backInStockTemplate) {
    if (!appContext.app?.templateMetadata) {
      console.error('context.app or context.app.templateMetadata is undefined');
    } else {
      const { templates = {} } = await getTemplateByIds(
        appContext,
        appContext.app.templateMetadata.themeNameLib,
        [{ name, id: appContext.app.templateMetadata[name] }]
      );

      backInStockTemplate = templates[appContext.app.templateMetadata[name]] || '';
    }
  }

  return {
    template: backInStockTemplate,
  };
}
